<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">个人资料</h1>
            <div class="u_avas">
                <img :src="userInfo.avatar" class="ava" id="ava">
                <!-- <input type="file" class="ava_ipt" id="avapt"> -->
                <p class="ua_name" id="nc0">{{userInfo.username}}</p>
                <p class="ua_id">ID:{{userInfo.id}}</p>
            </div>
            <div class="u_li">
                <em class="up_lft">昵称</em>
                <input type="text" name="other_name" id="other_name" v-model="userInfo.nickname" class="u_ipt">
            </div>
            <div class="u_li">
                <em class="up_lft">手机</em>{{userInfo.tel}}<em class="i_new f12 ml10">已验证</em>
            </div>
            <div class="u_li">
                <em class="up_lft">性别</em>
                <label class="u_lbl">
                    <input type="radio" name="sex" value="0" v-model="userInfo.sex"> 保密
                </label>
                <label class="u_lbl">
                    <input type="radio" name="sex" value="1" v-model="userInfo.sex"> 男
                </label>
                <label class="u_lbl">
                    <input type="radio" name="sex" value="2" v-model="userInfo.sex"> 女
                </label>
            </div>
            <p @click="u_tijiao()" class="u_tijiao">提交修改</p>
            <p class="lh30">&nbsp;</p>
            <p class="lh30">&nbsp;</p>
            <p class="bb_line"></p>
            <p class="lh30">&nbsp;</p>
            <h2 class="lr_bl">其他选项</h2>
            <a href="javascript:;" @click="$router.push({path: '/user_password'})" class="u_logout">修改密码</a>
            <a href="javascript:;" @click="lgouts()" class="u_logout">退出登录</a>
            <p onclick="zhuxiao()" class="u_logout hand">帐号注销</p>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            userInfo:JSON.parse(window.localStorage.getItem("user")),
        }
    },
    mounted(){
        this.getUserInfo();
    },
    methods:{
        getUserInfo(){
            var params = {};
            params.id = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getUser.getUserInfo(params).then(res=>{
                if(res.code == 200){
                    this.userInfo = res.result;
                }
            })
        },
        lgouts(){
            /*删除cookie*/
			localStorage.clear();
			this.$router.push({name:"Login"})
        },
        u_tijiao(){
            // var params = {};
            // params.id = JSON.parse(window.localStorage.getItem("user")).id || "";
            // params.im = JSON.parse(window.localStorage.getItem("user")).im || "";
            // if (this.userInfo.nickname.length > 6) {
            //     // this.$toast("昵称最多六个中文");
            //     this.$alert('昵称最多六个中文', '提示', {
            //         confirmButtonText: '确定',
            //     });
            //     return false;
            // }
            var params = {
                uid : JSON.parse(window.localStorage.getItem("user")).id || "",
                im : JSON.parse(window.localStorage.getItem("user")).im || "",
                nickname: this.userInfo.nickname,
                sex: this.userInfo.sex,
                avatar: this.userInfo.avatar || "",
                wx_lx_ewm: this.userInfo.wx_lx_ewm,
            };
            this.$api.getUser.setMyInfo(params).then((res) => {
                if (res.code == 200) {
                    if (this.isSDKReady && this.isLogin) {
                        this.$store.commit("updateUserInfo", {
                            gender: params.sex,
                            avatar: params.avatar,
                            nickname: params.nickname,
                        }); //修改Im资料
                    }
                    this.$alert('修改成功', '提示', {
                        confirmButtonText: '确定',
                    });
                    window.location.reload();
                }
            });
        }
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
.u_avas{overflow:hidden;height:70px;line-height:25px;padding:15px 0 0 0;zoom:1;position:relative;}
.ava_ipt{position:absolute;left:0;top:0;width:80px;height:80px;z-index:2;filter:alpha(opacity=0);opacity:0;}
.ava{width:55px;height:55px;float:left;margin-right:20px;border-radius:50%;}
.ua_name{font-size:30px;color:#000;font-weight: bold;margin-top:5px;}
.ua_id{font-size:10px;color:#999;}
.u_li{padding:10px 10px 10px 90px;line-height:42px;height:42px;font-size:14px;position:relative;overflow:hidden;display:block;zoom:1;}
.up_lft{color:#000;font-size:14px;position:absolute;left:0;top:10px;line-height:42px;}
.u_ipt{border:0;height:42px;line-height:42px;float:left;font-size:14px;width:200px;border:1px solid #eee;padding:0 10px;}
.u_tijiao{background-color:#f00180;line-height:50px;text-align:center;color:#ffffff;margin:20px 0;display:block;cursor:pointer;width:300px;margin-left:90px;font-size:16px;}
.u_logout{background-color:#fafafa;line-height:45px;text-align:center;color:#888;margin:20px 0;display:inline-block;width:200px;}
.u_lbl{vertical-align:middle;padding-right:20px;line-height:42px;}
.u_date{width:120px;cursor:pointer;border:1px solid #eee;line-height:42px;height:42px;margin-right:5px;}
</style>


// WEBPACK FOOTER //
// src/components/profile/Index.vue